import { combineReducers } from "redux";
import productReducers from "./productReducers";
import categoryReducers from "./categoryReducers";

const rootReducers = combineReducers({
  products: productReducers,
  categories: categoryReducers,
})

export default rootReducers